import { AnyAction } from 'redux'
import { AuthorizationActions } from '../userAccount/actionNames'
import { IEvent } from '../../models/Event'
import initialState from './initialState'
import { TaskActions } from './actionNames'

export default function(
  store: Readonly<ITaskStore> = initialState,
  action: AnyAction,
) {
  switch (action.type) {
    case AuthorizationActions.SignOffTheAccount:
    case AuthorizationActions.FlushState:
      return {
        ...initialState,
      }
    case TaskActions.TaskAccepted:
      return {
        ...store,
        cleaning: action.cleaning,
        ending: action.ending,
        feeding: action.feeding,
        loading: false,
        noPayment: action.noPayment,
        starting: action.starting,
      }
    case TaskActions.LoadTask:
      return {
        ...store,
        loading: true,
      }
    case TaskActions.UpdateTask:
      return action.task
        ? {
            ...store,
            [action.task]: store[action.task].map(e =>
              e.id === action.eventId ? action.event : e,
            ),
          }
        : {
            ...store,
            cleaning: store.cleaning.map(e =>
              e.id === action.eventId ? action.event : e,
            ),
            ending: store.ending.map(e =>
              e.id === action.eventId ? action.event : e,
            ),
            noPayment: store.noPayment.map(e =>
              e.id === action.eventId ? action.event : e,
            ),
            starting: store.starting.map(e =>
              e.id === action.eventId ? action.event : e,
            ),
          }
  }

  return store
}

export interface ITaskStore {
  date: Date
  loading: boolean
  starting: IEvent[]
  ending: IEvent[]
  noPayment: IEvent[]
  cleaning: IEvent[] & { tasks: string }
  feeding: {
    breakfast: { adults: number; kids: number }
    dinner: { adults: number; kids: number }
    supper: { adults: number; kids: number }
  }
}
